import * as Leaflet from "leaflet";
import { Path, withLeaflet, PathProps } from "react-leaflet";
import "leaflet-curve";

interface ICurveProps extends PathProps {
  curvePath: any[];
}

class CurvePath extends Path<ICurveProps, Leaflet.Path> {
  createLeafletElement(props: ICurveProps): Leaflet.Path {
    // @ts-ignore
    return Leaflet.curve(props.curvePath, props);
  }

  updateLeafletElement(fromProps: ICurveProps, toProps: ICurveProps): void {
    if (toProps.curvePath !== fromProps.curvePath) {
      // @ts-ignore
      this.leafletElement.setPath(toProps.curvePath);
    }

    this.setStyleIfChanged(fromProps, toProps);

    //Support class modif on rerender
    if (fromProps.className !== toProps.className) {
      const fromClasses = fromProps.className
        ? fromProps.className.split(" ")
        : [];
      const toClasses = toProps.className ? toProps.className.split(" ") : [];
      const toRemove = fromClasses.filter((x) => !toClasses.includes(x));
      const toAdd = toClasses.filter((x) => !fromClasses.includes(x));
      // @ts-ignore
      this.leafletElement._path.classList.remove(toRemove);
      // @ts-ignore
      this.leafletElement._path.classList.add(toAdd);
    }
  }
}

export default withLeaflet(CurvePath);
